<template>
  <!-- 在这里定义一个组件，显示一般的文本和一个输入框。目的是为了在表格初始化渲染的时候，页面加载速度能快一点儿，但是点击的时候再进行文字的输入。
      文本样式为输入框的样式，默认宽度为100%。初始渲染的时，显示纯文本。初始值从props中获取。input改变时，更新父组件的值。
      点击纯文本时，显示输入框，输入框失焦时，显示纯文本。当输入框失焦时，触发组件的blur事件，事件参数为输入框的值。
      同时也要为纯文本添加上必填校验的样式。建议可以给纯文本定义的class保持跟element-ui一致，包括纯文本显示的元素结构也可以参考element-ui中input的元素结构。
    -->
  <div class="table-input">
    <div 
        v-if="!showInput || disabled" 
        :class="{ 'is-required': required, 'el-input--mini': !disabled, 'el-input': !disabled, 'el-input--disabled': disabled }"
        @click="showInput = true"
    >
      <span v-if="inputValue || inputValue === 0" :class="{'el-input__inner': !disabled}">{{inputValue}}</span>
      <span v-else class="placeholder" :class="{'el-input__inner': !disabled}">{{placeholder}}</span>
    </div>
    <el-input 
        v-else 
        ref="input" 
        v-model="inputValue"
        v-bind="$attrs"
        @blur="handleBlur"
        @change="handleChange"
        @keyup.enter="handleBlur"
    />
  </div>
</template>

<script>
  export default {
    name: "TableInput",
    props: {
      value: {
        type: [String, Number],
        default: "",
      },
      width: {
        type: String,
        default: "100%",
      },
      required: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        showInput: false,
        inputValue: "",
      };
    },
    watch: {
      value: {
        handler(newVal) {
          this.inputValue = newVal;
        },
        immediate: true,
      },
      inputValue: {
        handler(newVal) {
          this.$emit("input", newVal);
        },
      },
    },
    mounted() {
      // 当显示输入框时，自动聚焦
      this.$watch("showInput", (newVal) => {
        if (newVal) {
          this.$nextTick(() => {
            if (this.$refs.input) {
              this.$refs.input.focus();
            }
          });
        }
      });
    },
    methods: {
      handleBlur() {
        this.showInput = false;
        this.$emit("blur", this.inputValue);
      },
      handleChange() {
        this.$emit("change", this.inputValue);
      },
    },
  };
</script>

<style scoped lang="scss">
.table-input {
  width: 100%;
  height: 29px;
  box-sizing: border-box;
  color: #444;
  
  .el-input {
    width: 100%;
    .el-input__inner{
      text-align: left;
      overflow: hidden;
    }
  }
  .el-input--disabled{
    font-size: 12px;
  }
  .placeholder{
    color: #c4c5c7;
  }
}
</style>